/* eslint import/no-anonymous-default-export: [2, {"allowArray": true}] */
export default [
  {
    id: 1,
    name: "Chicken Breast",
    apiParam: "chicken+breast",
    img: "/images/ingredients/chicken-breasts.png",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 165,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 3.6,
          unit: "g",
        },
        {
          name: "protein",
          amount: 31,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 0,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 2,
    name: "Potato",
    apiParam: "potato",
    img: "/images/ingredients/potatoes.png",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 77,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.1,
          unit: "g",
        },
        {
          name: "protein",
          amount: 2.1,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 17,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 3,
    name: "Carrot",
    apiParam: "carrot",
    img: "/images/ingredients/sliced-carrot.png",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 41,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.2,
          unit: "g",
        },
        {
          name: "protein",
          amount: 0.9,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 9.6,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 4,
    name: "Onion",
    apiParam: "onion",
    img: "/images/ingredients/brown-onion.png",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 40,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.1,
          unit: "g",
        },
        {
          name: "protein",
          amount: 1.1,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 9.3,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 5,
    name: "Olive Oil",
    apiParam: "olive+oil",
    img: "/images/ingredients/olive-oil.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 884,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 100,
          unit: "g",
        },
        {
          name: "protein",
          amount: 0,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 0,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 6,
    name: "Salt",
    apiParam: "salt",
    img: "/images/ingredients/salt.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 0,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0,
          unit: "g",
        },
        {
          name: "protein",
          amount: 0,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 0,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 7,
    name: "Pepper",
    apiParam: "pepper",
    img: "/images/ingredients/pepper.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 251,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 3.3,
          unit: "g",
        },
        {
          name: "protein",
          amount: 10,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 64,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 8,
    name: "Chicken Tigh",
    apiParam: "chicken+thigh",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 440,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 44,
          unit: "g",
        },
        {
          name: "protein",
          amount: 9.6,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 0.8,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 9,
    name: "Mushroom",
    apiParam: "mushroom",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 22,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.3,
          unit: "g",
        },
        {
          name: "protein",
          amount: 3.1,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 3.3,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 10,
    name: "Rolled Oats",
    apiParam: "rolled+oats",
    img: "/images/ingredients/rolled-oats.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 379,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 6.52,
          unit: "g",
        },
        {
          name: "protein",
          amount: 13.15,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 67.7,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 11,
    name: "Peach",
    apiParam: "peach",
    img: "/images/ingredients/peach.png",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 39,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.3,
          unit: "g",
        },
        {
          name: "protein",
          amount: 0.9,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 10,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 12,
    name: "Cashew Milk",
    apiParam: "cashew+milk",
    img: "/images/ingredients/cashews.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 66,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 4.65,
          unit: "g",
        },
        {
          name: "protein",
          amount: 1.9,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 4.44,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 13,
    name: "Coconut Cream",
    apiParam: "coconut+cream",
    img: "/images/ingredients/coconut-cream.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 327,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 34.7,
          unit: "g",
        },
        {
          name: "protein",
          amount: 3.6,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 6.7,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 14,
    name: "Cinnamon",
    apiParam: "cinnamon",
    img: "/images/ingredients/cinnamon.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 247,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 1.2,
          unit: "g",
        },
        {
          name: "protein",
          amount: 4,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 81,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 15,
    name: "Chia",
    apiParam: "chia",
    img: "/images/ingredients/chia-seeds.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 486,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 31,
          unit: "g",
        },
        {
          name: "protein",
          amount: 17,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 42,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 16,
    name: "Maple Syrup",
    apiParam: "maple+syrup",
    img: "/images/ingredients/maple-syrup-or-agave-nectar.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 260,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.1,
          unit: "g",
        },
        {
          name: "protein",
          amount: 0,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 67,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 17,
    name: "Pecans",
    apiParam: "pecans",
    img: "/images/ingredients/pecans.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 196,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 20.5,
          unit: "g",
        },
        {
          name: "protein",
          amount: 2.5,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 4,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 18,
    name: "Parsley",
    apiParam: "parsley",
    img: "/images/ingredients/parsley-curly.png",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 36,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.8,
          unit: "g",
        },
        {
          name: "protein",
          amount: 3,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 6.3,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 19,
    name: "Tomato",
    apiParam: "tomato",
    img: "/images/ingredients/roma-tomatoes.png",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 18,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.2,
          unit: "g",
        },
        {
          name: "protein",
          amount: 0.9,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 3.9,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 20,
    name: "Cucumber",
    apiParam: "cucumber",
    img: "/images/ingredients/cucumber.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 12,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.2,
          unit: "g",
        },
        {
          name: "protein",
          amount: 0.6,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 2.2,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 21,
    name: "Vinegar",
    apiParam: "vinegar",
    img: "/images/ingredients/vinegar-(white).jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 21,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0,
          unit: "g",
        },
        {
          name: "protein",
          amount: 0,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 0.9,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 22,
    name: "Oregano",
    apiParam: "oregano",
    img: "/images/ingredients/oregano.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 265,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 4.3,
          unit: "g",
        },
        {
          name: "protein",
          amount: 9,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 69,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 23,
    name: "Feta",
    apiParam: "feta+cheese",
    img: "/images/ingredients/feta.png",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 264,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 21,
          unit: "g",
        },
        {
          name: "protein",
          amount: 14,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 4.1,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 24,
    name: "Kalamata Olives",
    apiParam: "kalamata+olives",
    img: "/images/ingredients/calamata-or-kalamata-olives.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 226,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 22.5,
          unit: "g",
        },
        {
          name: "protein",
          amount: 1.8,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 3.9,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 25,
    name: "Burger buns",
    apiParam: "burger+buns",
    img: "/images/ingredients/hamburger-bun.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 245,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 2,
          unit: "g",
        },
        {
          name: "protein",
          amount: 9,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 47,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 26,
    name: "Eggplant",
    apiParam: "eggplant",
    img: "/images/ingredients/eggplant.png",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 25,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.2,
          unit: "g",
        },
        {
          name: "protein",
          amount: 1,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 5.9,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 27,
    name: "Haloumi",
    apiParam: "haloumi",
    img: "/images/ingredients/haloumi.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 313,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 24.6,
          unit: "g",
        },
        {
          name: "protein",
          amount: 22,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 0.8,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 28,
    name: "Harissa mayonnaise",
    apiParam: "harissa+mayonnaise",
    img: "/images/ingredients/mayonnaise.png",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 684,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 74,
          unit: "g",
        },
        {
          name: "protein",
          amount: 1.6,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 1.8,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 29,
    name: "Red Onion",
    apiParam: "red+onion",
    img: "/images/ingredients/red-onion.png",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 40,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.1,
          unit: "g",
        },
        {
          name: "protein",
          amount: 1.1,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 9.3,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 30,
    name: "Arugula (Rocket) Salad",
    apiParam: "arugula+rocket+salad",
    img: "/images/ingredients/arugula-or-rocket-salad.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 25,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.7,
          unit: "g",
        },
        {
          name: "protein",
          amount: 2.6,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 3.7,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 31,
    name: "Cherry Tomato",
    apiParam: "cherry+tomato",
    img: "/images/ingredients/cherry-tomatoes.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 18,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 0.2,
          unit: "g",
        },
        {
          name: "protein",
          amount: 0.9,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 3.9,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 32,
    name: "Whole Bread",
    apiParam: "whole+bread",
    img: "/images/ingredients/whole-bread.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 252,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 3.5,
          unit: "g",
        },
        {
          name: "protein",
          amount: 12,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 43,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 33,
    name: "Aged Cheese",
    apiParam: "aged+cheese",
    img: "/images/ingredients/aged-cheese.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 357,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 29,
          unit: "g",
        },
        {
          name: "protein",
          amount: 25,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 1.4,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 34,
    name: "Green Olives",
    apiParam: "green+olives",
    img: "/images/ingredients/green-olives--sliced.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 145,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 15,
          unit: "g",
        },
        {
          name: "protein",
          amount: 1,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 3.8,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 35,
    name: "Black Olives",
    apiParam: "black+olives",
    img: "/images/ingredients/black-olives.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 105,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 9.5,
          unit: "g",
        },
        {
          name: "protein",
          amount: 0.9,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 6.1,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
  {
    id: 36,
    name: "Mixed Olives",
    apiParam: "mixed+olives",
    img: "/images/ingredients/olives-mixed.jpg",
    nutritionPer100g: {
      nutrients: [
        {
          name: "calories",
          amount: 125,
          unit: "cal",
        },
        {
          name: "fat",
          amount: 12,
          unit: "g",
        },
        {
          name: "protein",
          amount: 0.9,
          unit: "g",
        },

        {
          name: "carbohidrates",
          amount: 5,
          unit: "g",
        },
      ],
    },
    isSelected: false,
  },
];
